/**
 * 2nd STP Status filter options for the Pharma STP File table.
 *
 * The shared submission-summary list plus Call and Fax, which the non-EPA modal
 * writes to `second_stp_status` on save. They are appended here rather than in
 * the shared constant so they do not become selectable in the submission
 * summary modal's own Second STP Status dropdown.
 */

import { SECOND_STP_STATUS_OPTIONS } from "../../../../constants/submissionSummaryOptions";
import {
  SecondStpStatus,
  SecondStpStatusLabels,
} from "../../../../enums/secondStpStatus";

const NON_EPA_OUTCOMES = [SecondStpStatus.CALL, SecondStpStatus.FAX];

export const allSecondStpStatusOptions = [
  ...SECOND_STP_STATUS_OPTIONS.map((option) => ({
    label: option.text,
    value: option.id,
  })),
  ...NON_EPA_OUTCOMES.map((status) => ({
    label: SecondStpStatusLabels[status],
    value: status,
  })),
];
